import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";
import Alert from "react-bootstrap/Alert";

import { myGlobals, myUtilities } from "../../Utils";
import { isTopBuild, globalVars} from "../../App";
import { AlertDialog } from "../Common";
import highradius from "../../Images/highradiusLogo.jpg";
import highradius2 from "../../Images/HRC.svg";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import LanguageDropDown from "../LanguageDropDown";
import {PaymentContainer} from "../Payment";

import { SupplierLogoContainer, InvoiceDiv } from "./";
import ModernUX from "../../ModernUX/ModernUX";


class MainApp extends React.Component {
  constructor(props) {
    super(props);
    myGlobals.getHistory = this.props.history;
    globalVars.selectedCard = -1;
    globalVars.paymentCardKeyCount = new Set();
    console.log("constructed main");
    myGlobals.injectProp = this.props.intl;
  }
  componentDidMount = () => {
    let width = document.getElementById(
      "pay-through-email-payment-container-id"
    )?.clientWidth;
    if(document.getElementById("invoice-div-id"))
        document.getElementById("invoice-div-id").style.marginTop = "50px";
  };
  showAlert = (data) => {
    if (data.state.showToast) {
      return (
        <Alert
          className="my-alert-class"
          variant="danger"
          onClose={() => data.setAlertShow(false)}
        >
          <p>Coming Soon!</p>
        </Alert>
      );
    }
  };
  decideLogoPath = () => highradius2;
  
  modernUxTheme = (data) => <ModernUX history={this.props.history} /> ;

  render() {
    return (
    		<Subscribe to={[PaymentDataContainer]}>
            {(data) =>
              myGlobals.currentTheme === "modernUX.css"
                ? this.modernUxTheme(data)
                : <Container>
                <AlertDialog />
                {this.showAlert(data)}
                <SupplierLogoContainer history={this.props.history} />
                <LanguageDropDown />
                <Row className="main-container no-gutter">
                  <Col sm={5}>
                    <InvoiceDiv />
                  </Col>
                  <Col sm={7}>
                    <PaymentContainer />
                  </Col>
                </Row>
                <Row className="highradius-credit-row">
                  {/* // top build footer */}
                  <Col className="highradius-credit">
                  <div>
                    {myUtilities.accountSpecificLanguage("refreshFooterAlert", "Do not refresh or click browser back")}
                  </div>
                  <div>
                    {myUtilities.accountSpecificLanguage("poweredby", "Powered By")}
                    <img
                      src={this.decideLogoPath()}
                      className="highradius-logo"
                      alt="Highradius Logo"
                    />
                  </div>
                  </Col>
                </Row>
              </Container>
            }
          </Subscribe>
    );
  }
}

export default MainApp;
